import Calc from "@/common/util/calculator"
import BaseScrewFixmethod from "@/signomatic/app/fixmethods/base_screw"

export default class ScrewAluFixmethod extends BaseScrewFixmethod {
  positions() {
    const { shape, border, width, widthPx, height, heightPx, metaProduct } = this.state
    const signType = this.drawables.signType
    const cappedScrew = this.state.fixmethod === "screw_capped"
    const positions = []
    let distance = 0
    let diameter = 0
    let headDiameter = 0

    switch (signType) {
      case "aluminium_sign":
      case "label_plates":
        diameter = Calc.mmToPx(4)
        headDiameter = Calc.mmToPx(7)
        break
      case "acryl_sign":
        diameter = Calc.mmToPx(4.3)
        headDiameter = Calc.mmToPx(8)
        break
    }

    if (cappedScrew) {
      headDiameter = width > 399 || height > 399 || signType == "acryl_sign" ? Calc.mmToPx(15) : Calc.mmToPx(10)
    }

    let fourScrews = (height >= 100 && shape !== "ellipse") || height >= 600
    let sixScrews = width > 999 && shape !== "ellipse"
    const defaults = { diameter, headDiameter }
    const centerV = heightPx / 2 - diameter / 2

    if (shape === "triangle") {
      const min = cappedScrew ? Calc.mmToPx(8) : Calc.mmToPx(6.5)
      const max = cappedScrew ? Calc.mmToPx(20) : Calc.mmToPx(border ? 20 : 14)
      distance = this.drawables.sizeRelative("height", min, max)

      const offset = Calc.triangleHorizontalOffset(widthPx, heightPx, distance)
      const minTop = cappedScrew ? Calc.mmToPx(15) : Calc.mmToPx(border ? 13 : 12.5)
      const maxTop = cappedScrew ? Calc.mmToPx(30) : Calc.mmToPx(20)
      const distanceTop = this.drawables.sizeRelative("height", minTop, maxTop)

      const center = widthPx / 2 - diameter / 2
      const top = distanceTop - diameter / 2
      const topStretch = distance - headDiameter / 2
      const bottom = heightPx - diameter / 2 - distance
      const left = offset + distance - diameter / 2
      const right = widthPx - offset - diameter / 2 - distance

      positions.push({ ...defaults, left: center, top })
      positions.push({ ...defaults, left, top: bottom })
      positions.push({ ...defaults, left: right, top: bottom })
      positions.push({ ...defaults, left: center, top: topStretch, stretch: true })
    } else if (shape === "ellipse") {
      if (signType == "acryl_sign") {
        if (cappedScrew) {
          distance = fourScrews
            ? this.drawables.sizeRelative("width", Calc.mmToPx(15), Calc.mmToPx(25))
            : this.drawables.sizeRelative("width", Calc.mmToPx(10), Calc.mmToPx(15))
        } else {
          distance = fourScrews
            ? this.drawables.sizeRelative("width", Calc.mmToPx(12), Calc.mmToPx(20))
            : this.drawables.sizeRelative("width", Calc.mmToPx(9), Calc.mmToPx(12))
        }
      } else if (cappedScrew) {
        distance = fourScrews
          ? this.drawables.sizeRelative("height", Calc.mmToPx(20), Calc.mmToPx(25))
          : this.drawables.sizeRelative("width", Calc.mmToPx(7), Calc.mmToPx(20))
      } else {
        distance = fourScrews
          ? this.drawables.sizeRelative("height", Calc.mmToPx(13), Calc.mmToPx(20))
          : this.drawables.sizeRelative("width", Calc.mmToPx(7), Calc.mmToPx(13))
      }
      const minTop = cappedScrew ? Calc.mmToPx(20) : Calc.mmToPx(13)
      const maxTop = cappedScrew ? Calc.mmToPx(25) : Calc.mmToPx(20)
      const distanceTop = this.drawables.sizeRelative("height", minTop, maxTop)

      const left = distance - diameter / 2
      const right = widthPx - distance - diameter / 2
      const centerH = widthPx / 2 - diameter / 2
      const top = distanceTop - diameter / 2
      const bottom = heightPx - diameter / 2 - distance

      positions.push({ ...defaults, left, top: centerV })
      positions.push({ ...defaults, left: right, top: centerV })

      if (fourScrews) {
        positions.push({ ...defaults, left: centerH, top: top })
        positions.push({ ...defaults, left: centerH, top: bottom })
      }
    } else if (shape === "stop") {
      distance = this.drawables.sizeRelative("height", Calc.mmToPx(7), Calc.mmToPx(13), { maxHeight: 600 })
      const left = distance - diameter / 2
      const right = widthPx - diameter / 2 - distance

      positions.push({ ...defaults, left, top: centerV })
      positions.push({ ...defaults, left: right, top: centerV })
    } else if (shape === "rotated_rect") {
      distance =
        height < 100
          ? this.drawables.sizeRelative("height", Calc.mmToPx(8), Calc.mmToPx(10), { maxHeight: 100 })
          : this.drawables.sizeRelative("height", Calc.mmToPx(10), Calc.mmToPx(30), { minHeight: 100, maxHeight: 600 })

      if (cappedScrew) {
        distance =
          height < 100
            ? Calc.mmToPx(16)
            : this.drawables.sizeRelative("height", Calc.mmToPx(16), Calc.mmToPx(30), {
                minHeight: 100,
                maxHeight: 600,
              })
      }
      const center = widthPx / 2 - diameter / 2
      const top = distance - diameter / 2
      const bottom = heightPx - diameter / 2 - distance
      const left = distance - diameter / 2
      const right = widthPx - diameter / 2 - distance

      positions.push({ ...defaults, left, top: centerV })
      positions.push({ ...defaults, left: right, top: centerV })

      if (height > 99) {
        positions.push({ ...defaults, left: center, top: top })
        positions.push({ ...defaults, left: center, top: bottom })
      }
    } else if (["direction_left", "direction_right", "arrow_left", "arrow_right"].includes(shape)) {
      let distanceFront = this.drawables.sizeRelative("width", Calc.mmToPx(7), Calc.mmToPx(18), { maxWidth: 600 })
      let distanceBack = this.drawables.sizeRelative("width", Calc.mmToPx(4), Calc.mmToPx(8), { maxWidth: 600 })

      if (cappedScrew) {
        distanceFront = border
          ? this.drawables.sizeRelative("width", Calc.mmToPx(10), Calc.mmToPx(19), { maxWidth: 600 })
          : this.drawables.sizeRelative("width", Calc.mmToPx(10), Calc.mmToPx(15), { maxWidth: 600 })
        distanceBack = border
          ? this.drawables.sizeRelative("width", Calc.mmToPx(9), Calc.mmToPx(20), { maxWidth: 600 })
          : this.drawables.sizeRelative("width", Calc.mmToPx(7), Calc.mmToPx(10), { maxWidth: 600 })
      }

      let left = distanceFront - diameter / 2
      let right = widthPx - diameter / 2 - distanceBack

      if (shape === "direction_right" || shape == "arrow_right") {
        left = distanceBack - diameter / 2
        right = widthPx - diameter / 2 - distanceFront
        positions.push({
          ...defaults,
          left: widthPx - diameter / 2 - distanceBack,
          top: centerV,
          stretch: true,
        })
      } else {
        positions.push({
          ...defaults,
          left: distanceBack - diameter / 2,
          top: centerV,
          stretch: true,
        })
      }

      positions.push({ ...defaults, left, top: centerV })
      positions.push({ ...defaults, left: right, top: centerV })
    } else if (["rounded_top", "rounded_sides", "curved_top", "arched_top"].includes(shape)) {
      fourScrews = width >= 199 && width <= 600
      sixScrews = width > 600

      let distanceSide = 0
      let distanceTop = 0

      const fourScrewOpts = { minWidth: 199, maxWidth: 600, minHeight: 199, maxHeight: 600 }
      const sixScrewOpts = { minWidth: 600, minHeight: 600 }

      if (["aluminium_sign", "label_plates"].includes(signType)) {
        if (metaProduct === "house_sign") {
          fourScrews = width >= 199 && width <= 599
          sixScrews = width > 599
          if (fourScrews) {
            if (shape == "arched_top") {
              distanceSide = Calc.mmToPx(11)
              distanceTop = this.drawables.sizeRelative("height", Calc.mmToPx(77), Calc.mmToPx(220), fourScrewOpts)
            } else if (shape == "rounded_top") {
              distanceSide = this.drawables.sizeRelative("width", Calc.mmToPx(10), Calc.mmToPx(12), fourScrewOpts)
              distanceTop = this.drawables.sizeRelative("height", Calc.mmToPx(30), Calc.mmToPx(80), fourScrewOpts)
            } else if (shape == "rounded_sides") {
              distanceSide = this.drawables.sizeRelative("width", Calc.mmToPx(24), Calc.mmToPx(67), fourScrewOpts)
              distanceTop = this.drawables.sizeRelative("height", Calc.mmToPx(10), Calc.mmToPx(12), fourScrewOpts)
            } else if (shape == "curved_top") {
              distance = this.drawables.sizeRelative("width", Calc.mmToPx(10), Calc.mmToPx(13), fourScrewOpts)
              const curveTop = this.drawables.sizeRelative("height", Calc.mmToPx(80), Calc.mmToPx(247), fourScrewOpts)

              const left = distance - diameter / 2
              const top = distance - diameter / 2
              const right = widthPx - distance - diameter / 2
              const bottom = heightPx - Calc.mmToPx(11) - diameter / 2

              positions.push({ ...defaults, left, top })
              positions.push({ ...defaults, left, top: bottom })
              positions.push({ ...defaults, left: right, top: curveTop })
              positions.push({ ...defaults, left: right, top: bottom })

              return positions
            }
          } else if (sixScrews) {
            if (shape == "arched_top") {
              distanceSide = Calc.mmToPx(11)
              distanceTop = this.drawables.sizeRelative("height", Calc.mmToPx(220), Calc.mmToPx(438), sixScrewOpts)
            } else if (shape == "rounded_top") {
              distanceSide = this.drawables.sizeRelative("width", Calc.mmToPx(12), Calc.mmToPx(14), sixScrewOpts)
              distanceTop = this.drawables.sizeRelative("height", Calc.mmToPx(75), Calc.mmToPx(130), sixScrewOpts)
            } else if (shape == "rounded_sides") {
              distanceSide = this.drawables.sizeRelative("width", Calc.mmToPx(67), Calc.mmToPx(208), sixScrewOpts)
              distanceTop = this.drawables.sizeRelative("height", Calc.mmToPx(12), Calc.mmToPx(14), sixScrewOpts)
            } else if (shape == "curved_top") {
              distance = this.drawables.sizeRelative("width", Calc.mmToPx(13), Calc.mmToPx(15), sixScrewOpts)
              const curveTop = this.drawables.sizeRelative("height", Calc.mmToPx(247), Calc.mmToPx(490), sixScrewOpts)
              const min = cappedScrew ? Calc.mmToPx(29) : Calc.mmToPx(27)
              const middleTop = this.drawables.sizeRelative("height", min, Calc.mmToPx(120), {
                minHeight: 200,
              })
              const centerH = widthPx / 2 - diameter / 2

              const left = distance - diameter / 2
              const top = distance - diameter / 2
              const right = widthPx - distance - diameter / 2
              const bottom = heightPx - Calc.mmToPx(11) - diameter / 2

              positions.push({ ...defaults, left, top })
              positions.push({ ...defaults, left, top: bottom })
              positions.push({ ...defaults, left: right, top: curveTop })
              positions.push({ ...defaults, left: right, top: bottom })
              positions.push({ ...defaults, left: centerH, top: middleTop })
              positions.push({ ...defaults, left: centerH, top: bottom })

              return positions
            }
          } else {
            distanceSide = Calc.mmToPx(9.5)
          }
        } else if (fourScrews) {
          // door_sign
          if (cappedScrew) {
            if (shape == "arched_top") {
              distanceSide = Calc.mmToPx(11)
              distanceTop = this.drawables.sizeRelative("height", Calc.mmToPx(77), Calc.mmToPx(222), fourScrewOpts)
            } else if (shape == "rounded_top") {
              distanceSide = Calc.mmToPx(11)
              distanceTop = this.drawables.sizeRelative("height", Calc.mmToPx(26), Calc.mmToPx(72), fourScrewOpts)
            } else if (shape == "rounded_sides") {
              distanceSide = this.drawables.sizeRelative("width", Calc.mmToPx(27), Calc.mmToPx(70), fourScrewOpts)
              distanceTop = Calc.mmToPx(10)
            } else if (shape == "curved_top") {
              distance = this.drawables.sizeRelative("width", Calc.mmToPx(10), Calc.mmToPx(13), fourScrewOpts)
              const curveTop = this.drawables.sizeRelative("height", Calc.mmToPx(82), Calc.mmToPx(244), fourScrewOpts)

              const left = distance - diameter / 2
              const top = distance - diameter / 2
              const right = widthPx - distance - diameter / 2
              const bottom = heightPx - Calc.mmToPx(10) - diameter / 2

              positions.push({ ...defaults, left, top })
              positions.push({ ...defaults, left, top: bottom })
              positions.push({ ...defaults, left: right, top: curveTop })
              positions.push({ ...defaults, left: right, top: bottom })

              return positions
            }
          } else {
            if (shape == "arched_top") {
              distanceSide = Calc.mmToPx(11)
              distanceTop = this.drawables.sizeRelative("height", Calc.mmToPx(77), Calc.mmToPx(218), fourScrewOpts)
            } else if (shape == "rounded_top") {
              distanceSide = Calc.mmToPx(10)
              distanceTop = this.drawables.sizeRelative("height", Calc.mmToPx(24), Calc.mmToPx(67), fourScrewOpts)
            } else if (shape == "rounded_sides") {
              distanceSide = this.drawables.sizeRelative("width", Calc.mmToPx(27), Calc.mmToPx(68), fourScrewOpts)
              distanceTop = Calc.mmToPx(10)
            } else if (shape == "curved_top") {
              distance = this.drawables.sizeRelative("width", Calc.mmToPx(10), Calc.mmToPx(13), fourScrewOpts)
              const curveTop = this.drawables.sizeRelative("height", Calc.mmToPx(82), Calc.mmToPx(244), fourScrewOpts)

              const left = distance - diameter / 2
              const top = distance - diameter / 2
              const right = widthPx - distance - diameter / 2
              const bottom = heightPx - Calc.mmToPx(10) - diameter / 2

              positions.push({ ...defaults, left, top })
              positions.push({ ...defaults, left, top: bottom })
              positions.push({ ...defaults, left: right, top: curveTop })
              positions.push({ ...defaults, left: right, top: bottom })

              return positions
            }
          }
        } else {
          distanceSide = Calc.mmToPx(9.5)
        }
      } else {
        // acryl_sign
        if (metaProduct === "house_sign") {
          if (fourScrews) {
            if (shape == "arched_top") {
              const min = cappedScrew ? Calc.mmToPx(80) : Calc.mmToPx(77)
              distanceSide = Calc.mmToPx(11)
              distanceTop = this.drawables.sizeRelative("height", min, Calc.mmToPx(226), fourScrewOpts)
            } else if ("rounded_top" == shape) {
              distanceSide = Calc.mmToPx(11)
              distanceTop = this.drawables.sizeRelative("height", Calc.mmToPx(30), Calc.mmToPx(64), fourScrewOpts)
            } else if ("rounded_sides" == shape) {
              distanceSide = this.drawables.sizeRelative("width", Calc.mmToPx(30), Calc.mmToPx(70), fourScrewOpts)
              distanceTop = Calc.mmToPx(11)
            } else if (shape == "curved_top") {
              distance = this.drawables.sizeRelative("width", Calc.mmToPx(11), Calc.mmToPx(13), fourScrewOpts)
              const curveTop = this.drawables.sizeRelative("height", Calc.mmToPx(85), Calc.mmToPx(248), fourScrewOpts)

              const left = distance - diameter / 2
              const top = distance - diameter / 2
              const right = widthPx - distance - diameter / 2
              const bottom = heightPx - Calc.mmToPx(11) - diameter / 2

              positions.push({ ...defaults, left, top })
              positions.push({ ...defaults, left, top: bottom })
              positions.push({ ...defaults, left: right, top: curveTop })
              positions.push({ ...defaults, left: right, top: bottom })

              return positions
            }
          } else if (sixScrews) {
            if (shape == "arched_top") {
              distanceSide = Calc.mmToPx(11)
              distanceTop = this.drawables.sizeRelative("height", Calc.mmToPx(226), Calc.mmToPx(332), sixScrewOpts)
            } else if ("rounded_top" == shape) {
              const max = cappedScrew ? Calc.mmToPx(110) : Calc.mmToPx(103)
              distanceSide = Calc.mmToPx(11)
              distanceTop = this.drawables.sizeRelative("height", Calc.mmToPx(75), max, sixScrewOpts)
            } else if ("rounded_sides" == shape) {
              distanceSide = this.drawables.sizeRelative("width", Calc.mmToPx(70), Calc.mmToPx(152), sixScrewOpts)
              distanceTop = Calc.mmToPx(11)
            } else if (shape == "curved_top") {
              distance = this.drawables.sizeRelative("width", Calc.mmToPx(13), Calc.mmToPx(15), sixScrewOpts)
              const curveTop = this.drawables.sizeRelative("height", Calc.mmToPx(248), Calc.mmToPx(370), sixScrewOpts)
              const middleTop = this.drawables.sizeRelative("height", Calc.mmToPx(60), Calc.mmToPx(80), sixScrewOpts)
              const centerH = widthPx / 2 - diameter / 2

              const left = distance - diameter / 2
              const top = distance - diameter / 2
              const right = widthPx - distance - diameter / 2
              const bottom = heightPx - Calc.mmToPx(11) - diameter / 2

              positions.push({ ...defaults, left, top })
              positions.push({ ...defaults, left, top: bottom })
              positions.push({ ...defaults, left: right, top: curveTop })
              positions.push({ ...defaults, left: right, top: bottom })
              positions.push({ ...defaults, left: centerH, top: middleTop })
              positions.push({ ...defaults, left: centerH, top: bottom })

              return positions
            }
          } else {
            distanceSide = Calc.mmToPx(11)
          }
        } else if (fourScrews) {
          // door_sign
          if (cappedScrew) {
            if (shape == "arched_top") {
              distanceSide = Calc.mmToPx(11)
              distanceTop = this.drawables.sizeRelative("height", Calc.mmToPx(79), Calc.mmToPx(222), fourScrewOpts)
            } else if ("rounded_top" == shape) {
              distanceSide = Calc.mmToPx(11)
              distanceTop = this.drawables.sizeRelative("height", Calc.mmToPx(30), Calc.mmToPx(72), fourScrewOpts)
            } else if ("rounded_sides" == shape) {
              distanceSide = this.drawables.sizeRelative("width", Calc.mmToPx(27), Calc.mmToPx(70), fourScrewOpts)
              distanceTop = Calc.mmToPx(10)
            } else if (shape == "curved_top") {
              distance = this.drawables.sizeRelative("width", Calc.mmToPx(10), Calc.mmToPx(13), fourScrewOpts)
              const curveTop = this.drawables.sizeRelative("height", Calc.mmToPx(84), Calc.mmToPx(246), fourScrewOpts)

              const left = distance - diameter / 2
              const top = distance - diameter / 2
              const right = widthPx - distance - diameter / 2
              const bottom = heightPx - Calc.mmToPx(10) - diameter / 2

              positions.push({ ...defaults, left, top })
              positions.push({ ...defaults, left, top: bottom })
              positions.push({ ...defaults, left: right, top: curveTop })
              positions.push({ ...defaults, left: right, top: bottom })

              return positions
            }
          } else {
            if (shape == "arched_top") {
              distanceSide = Calc.mmToPx(11)
              distanceTop = this.drawables.sizeRelative("height", Calc.mmToPx(77), Calc.mmToPx(218), fourScrewOpts)
            } else if ("rounded_top" == shape) {
              distanceSide = Calc.mmToPx(11)
              distanceTop = this.drawables.sizeRelative("height", Calc.mmToPx(24), Calc.mmToPx(67), fourScrewOpts)
            } else if ("rounded_sides" == shape) {
              distanceSide = this.drawables.sizeRelative("width", Calc.mmToPx(27), Calc.mmToPx(68), fourScrewOpts)
              distanceTop = Calc.mmToPx(10)
            } else if (shape == "curved_top") {
              distance = this.drawables.sizeRelative("width", Calc.mmToPx(10), Calc.mmToPx(13), fourScrewOpts)
              const curveTop = this.drawables.sizeRelative("height", Calc.mmToPx(82), Calc.mmToPx(244), fourScrewOpts)

              const left = distance - diameter / 2
              const top = distance - diameter / 2
              const right = widthPx - distance - diameter / 2
              const bottom = heightPx - Calc.mmToPx(10) - diameter / 2

              positions.push({ ...defaults, left, top })
              positions.push({ ...defaults, left, top: bottom })
              positions.push({ ...defaults, left: right, top: curveTop })
              positions.push({ ...defaults, left: right, top: bottom })

              return positions
            }
          }
        } else {
          distanceSide = Calc.mmToPx(11)
        }
      }

      const left = distanceSide - diameter / 2
      const top = distanceTop - diameter / 2
      let bottom = heightPx - distanceTop - diameter / 2
      const right = widthPx - distanceSide - diameter / 2
      let centerV = widthPx / 2 - diameter / 2
      const centerH = widthPx / 2 - diameter / 2
      let middleTop = top
      let middleBottom = bottom

      if (shape == "arched_top") {
        bottom = heightPx - distanceSide - diameter / 2
        middleBottom = heightPx - distanceSide - diameter / 2

        if (fourScrews) {
          positions.push({
            ...defaults,
            left: widthPx / 2 - diameter / 2,
            top: diameter / 2,
            stretch: true,
          })
        } else if (sixScrews) {
          middleTop = distanceSide - diameter / 2
        } else {
          // arcH constant also in arched_top
          const arcH = heightPx * 0.35
          const squareHeight = heightPx - arcH
          centerV = arcH + squareHeight / 2 - diameter / 2
          positions.push({
            ...defaults,
            left: widthPx / 2 - diameter / 2,
            top: heightPx - centerV - diameter,
            stretch: true,
          })
        }
      } else if (shape == "rounded_top" && sixScrews) {
        const middleDistance = Calc.mmToPx(11)
        middleTop = middleDistance - diameter / 2
        middleBottom = heightPx - middleDistance - diameter / 2
      }

      if (sixScrews) {
        positions.push({ ...defaults, left, top })
        positions.push({ ...defaults, left, top: bottom })
        positions.push({ ...defaults, left: right, top })
        positions.push({ ...defaults, left: right, top: bottom })
        positions.push({ ...defaults, left: centerH, top: middleTop })
        positions.push({ ...defaults, left: centerH, top: middleBottom })
      } else if (fourScrews) {
        positions.push({ ...defaults, left, top })
        positions.push({ ...defaults, left, top: bottom })
        positions.push({ ...defaults, left: right, top })
        positions.push({ ...defaults, left: right, top: bottom })
      } else {
        positions.push({ ...defaults, left, top: centerV })
        positions.push({ ...defaults, left: right, top: centerV })
      }
    } else {
      if (["aluminium_sign", "label_plates"].includes(signType)) {
        if (shape === "rect") {
          distance = fourScrews || sixScrews ? Calc.mmToPx(11) : Calc.mmToPx(8)
          if (cappedScrew) {
            if (fourScrews) {
              distance = Calc.mmToPx(12)
            } else if (sixScrews) {
              distance = Calc.mmToPx(14)
            }
          }
        } else if (shape === "round") {
          if (sixScrews) {
            if (this.state.fixmethod === "screw") {
              distance = this.drawables.sizeRelative("width", Calc.mmToPx(30), Calc.mmToPx(45), {
                minWidth: 999,
              })
            } else {
              // screw_capped
              distance = this.drawables.sizeRelative("width", Calc.mmToPx(30), Calc.mmToPx(50), {
                minWidth: 999,
              })
            }
          } else if (fourScrews) {
            if (this.state.fixmethod === "screw") {
              distance = this.drawables.sizeRelative("height", Calc.mmToPx(17), Calc.mmToPx(30), {
                minHeight: 99,
              })
            } else {
              // screw_capped
              distance = this.drawables.sizeRelative("height", Calc.mmToPx(11), Calc.mmToPx(30), {
                minHeight: 99,
              })
            }
          } else {
            distance = Calc.mmToPx(8)
          }
        } else if (shape === "ellipse") {
          if (this.state.fixmethod === "screw") {
            distance = this.drawables.sizeRelative("width", Calc.mmToPx(7), Calc.mmToPx(13))
          } else {
            // screw_capped
            distance = this.drawables.sizeRelative("width", Calc.mmToPx(7), Calc.mmToPx(17))
          }
        }
      } else if (signType === "acryl_sign") {
        if (shape === "rect") {
          if (sixScrews) {
            distance = this.drawables.sizeRelative("width", Calc.mmToPx(26), Calc.mmToPx(31), {
              minWidth: 999,
            })
          } else if (fourScrews) {
            distance = this.drawables.sizeRelative("height", Calc.mmToPx(11), Calc.mmToPx(26), {
              minHeight: 99,
            })
          } else {
            distance = Calc.mmToPx(11)
          }
        } else if (shape === "round") {
          if (sixScrews) {
            if (cappedScrew) {
              distance = this.drawables.sizeRelative("width", Calc.mmToPx(50), Calc.mmToPx(60), {
                minWidth: 999,
              })
            } else {
              distance = this.drawables.sizeRelative("width", Calc.mmToPx(50), Calc.mmToPx(58), {
                minWidth: 999,
              })
            }
          } else if (fourScrews) {
            distance = this.drawables.sizeRelative("height", Calc.mmToPx(11), Calc.mmToPx(50), {
              minHeight: 99,
            })
          } else {
            distance = Calc.mmToPx(11)
          }
        }
      }

      if (fourScrews && border === "retro" && height >= 100 && height <= 149) {
        distance = this.drawables.sizeRelative("height", Calc.mmToPx(7.5), Calc.mmToPx(11), {
          minHeight: 100,
          maxHeight: 149,
        })
      }

      const left = distance - diameter / 2
      const top = distance - diameter / 2
      const bottom = heightPx - distance - diameter / 2
      const right = widthPx - distance - diameter / 2
      const centerH = widthPx / 2 - diameter / 2
      const centerV = widthPx / 2 - diameter / 2

      if (sixScrews) {
        positions.push({ ...defaults, left: centerH, top })
        positions.push({ ...defaults, left: centerH, top: bottom })
      }

      if (fourScrews || sixScrews) {
        positions.push({ ...defaults, left, top })
        positions.push({ ...defaults, left, top: bottom })
        positions.push({ ...defaults, left: right, top })
        positions.push({ ...defaults, left: right, top: bottom })
      } else {
        positions.push({ ...defaults, left, top: centerV })
        positions.push({ ...defaults, left: right, top: centerV })
      }
    }

    return positions
  }
}
